import type { ChangeEvent } from 'react'

import { LoginPasswordInputBlock, LoginUsernameInputBlock } from "/app/libraries/arcana/src/blocks/InputBlock/Templates/index.ts"

import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import { useCallback } from 'react'
import { $passwordI18n, FROM } from '~/features/password-security'
import { $signUpFormTranslations } from '../../translations'
import { signUpForm, signUpFx } from '../model'

export const UsernameAndPasswordInputs = () => {
  const { fields, hasError, errorText } = useForm(signUpForm)
  const formTranslations = useUnit($signUpFormTranslations)
  const passwordTranslations = useUnit($passwordI18n)(FROM.FEATURES)

  const pending = useUnit(signUpFx.pending)
  const getErrorMessage = (type: Parameters<typeof errorText>[0]): string => {
    const text = errorText(type, formTranslations[type].errors)

    return hasError(type) ? text : ''
  }
  const handleChangeEmail = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => fields.email.onChange(e.target.value),
    [fields.email]
  )
  const handleChangeUsername = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      fields.username.onChange(e.target.value),
    [fields.username]
  )
  const handleChangePassword = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      fields.password.onChange(e.target.value),
    [fields.password]
  )
  const handleChangeConfirm = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      fields.confirm.onChange(e.target.value),
    [fields.confirm]
  )

  return (
    <>
      <LoginUsernameInputBlock
        value={fields.email.value}
        placeholder={formTranslations.email.placeholder}
        label={formTranslations.email.label}
        disabled={pending}
        onChange={handleChangeEmail}
        onBlur={() => fields.email.onBlur()}
        errorMessage={getErrorMessage('email')}
        autoComplete='off'
      />
      <LoginUsernameInputBlock
        value={fields.username.value}
        placeholder={formTranslations.username.placeholder}
        label={formTranslations.username.label}
        disabled={pending}
        onChange={handleChangeUsername}
        onBlur={() => fields.username.onBlur()}
        errorMessage={getErrorMessage('username')}
        autoComplete='off'
      />
      <LoginPasswordInputBlock
        value={fields.password.value}
        placeholder={passwordTranslations.placeholder}
        label={passwordTranslations.label}
        disabled={pending}
        onChange={handleChangePassword}
        onBlur={() => fields.password.onBlur()}
        errorMessage={
          hasError('password')
            ? errorText('password', passwordTranslations)
            : ''
        }
        autoComplete='new-password'
      />
      <LoginPasswordInputBlock
        value={fields.confirm.value}
        placeholder={formTranslations.confirm.placeholder}
        label={formTranslations.confirm.label}
        disabled={pending}
        onChange={handleChangeConfirm}
        onBlur={() => fields.confirm.onBlur()}
        errorMessage={getErrorMessage('confirm')}
        autoComplete='new-password'
      />
    </>
  )
}
